module.exports = __webpack_public_path__ + "img/76_5.1d2e2c77.png";